import { useAccessToken } from '@b-stock/fe-core/bstock-next/components'

const useIsLoggedIn = () => {
  const accessToken = useAccessToken()

  return !!accessToken
}

export default useIsLoggedIn
